import { SubscriptionItemDraft, SubscriptionItemType } from "../../types";
import { SubscriptionBulkExportItemDraftDTO, SubscriptionSavedBulkExportItemDraftDTO, SubscriptionSlideItemDraftDTO } from "../types";

export function subscriptionItemToDraftDTO(
  item: SubscriptionItemDraft
): SubscriptionBulkExportItemDraftDTO | SubscriptionSlideItemDraftDTO | SubscriptionSavedBulkExportItemDraftDTO {
  const {
    fileFormat,
    type,
    payload,
    schedule: { day, time, frequency, month },
    name,
  } = item;

  const gmtTime = `${time}+02:00`;

  if (type === SubscriptionItemType.BulkExport) {
    return {
      name,
      time: gmtTime,
      schedulerFrequency: frequency,
      fileFormat,
      subscriptionType: type,
      payload,
      day,
      month,
    };
  }

  if (type === SubscriptionItemType.SavedBulkExport) {
    return {
      name,
      time: gmtTime,
      schedulerFrequency: frequency,
      fileFormat,
      subscriptionType: type,
      payload,
      day,
      month,
    };
  }

  if (type === SubscriptionItemType.Slide) {
    return {
      name,
      day,
      time: gmtTime,
      schedulerFrequency: frequency,
      month,
      fileFormat,
      subscriptionType: type,
      payload: [payload],
    };
  }

  throw new Error("Unknown SubscriptionItemType");
}
